export const SET_CUSTOMER = 'SET_CUSTOMER';
export const RESET_CUSTOMER = 'RESET_CUSTOMER';
